import React from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';

export const ModalPendingUser = ({ isOpen, toggle, onCompleteSetup }) => {
    const handleCompleteSetup = (e) => {
        e.preventDefault();
        if (onCompleteSetup) {
            onCompleteSetup(e);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered size='md' className='close-circle'>
            <ModalHeader toggle={toggle} className='justify-content-center border-0 pb-0' />
            <ModalBody className='text-center'>
                <p className='mb-4'>
                    This user has not yet been validated. Please complete the set up by clicking below and entering the verification code sent to your email.
                </p>
                <Button color='green-light' size='sm' onClick={handleCompleteSetup}>
                    Send the verification code
                </Button>
            </ModalBody>
        </Modal>
    );
};
